import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-8">
          <Link to="/">
            <Button variant="ghost" size="sm">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Button>
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <h1 className="text-3xl font-bold mb-6">Refund Policy</h1>
          <p className="text-sm text-gray-500 mb-8">Effective Date: March 1, 2026</p>

          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Subscription Refunds</h2>
              <p className="text-gray-600 mb-4">
                We offer a full refund within the first 14 days of any paid subscription. After 14 days,
                subscriptions are non-refundable but you can cancel anytime to prevent future charges.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">How to Request a Refund</h2>
              <p className="text-gray-600 mb-4">
                Email us at support@team-skynet.io with your account email and reason for the refund.
                We'll process eligible refunds within 5-7 business days.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Cancellations</h2>
              <p className="text-gray-600 mb-4">
                You can cancel your subscription at any time through your account settings or Stripe
                customer portal. Your access continues until the end of the current billing period.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Free Tier</h2>
              <p className="text-gray-600 mb-4">
                The free tier requires no payment and has no refund implications.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Changes to This Policy</h2>
              <p className="text-gray-600 mb-4">
                We may update this policy from time to time. Changes will be posted on this page
                with an updated effective date.
              </p>
            </section>

            <div className="mt-12 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <p className="text-sm text-yellow-800">
                <strong>Note:</strong> This is a preliminary version of our Refund Policy pending legal review.
                The final version will be updated once reviewed by our legal team.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
